var map = {
	"./de/CardsBenefitsJune2025LP.json": [
		53846,
		53846
	],
	"./de/QuizBonusJune2025LP.json": [
		55214,
		55214
	],
	"./de/aviatorup.json": [
		60011,
		60011
	],
	"./de/banksBenefitsMay2025.json": [
		77207,
		77207
	],
	"./de/becomeVip.json": [
		44979,
		44979
	],
	"./de/bigBass.json": [
		84369,
		84369
	],
	"./de/blackWheelLP.json": [
		30241,
		30241
	],
	"./de/bonanzaPromo.json": [
		94504,
		94504
	],
	"./de/bonusClaimLP.json": [
		46295,
		46295
	],
	"./de/bonuses.json": [
		99915,
		99915
	],
	"./de/buffaloWheel.json": [
		90322,
		90322
	],
	"./de/carways2025LP.json": [
		43148,
		43148
	],
	"./de/cashbox.json": [
		78200,
		78200
	],
	"./de/cashupBonanza.json": [
		15087,
		15087
	],
	"./de/centredRegFormLP.json": [
		38325,
		38325
	],
	"./de/circleLP.json": [
		81184,
		81184
	],
	"./de/circusNovember.json": [
		57637,
		57637
	],
	"./de/common.json": [
		2938,
		2938
	],
	"./de/crownApril25.json": [
		68710,
		68710
	],
	"./de/crownBanner.json": [
		96026,
		96026
	],
	"./de/crownMarch25.json": [
		83105,
		83105
	],
	"./de/crownWheelBlack.json": [
		92486,
		92486
	],
	"./de/crownWheelBlackLP.json": [
		35124,
		35124
	],
	"./de/cryptoExclusiveMay25LP.json": [
		14387,
		14387
	],
	"./de/cryptoOfferMay25LP.json": [
		95007,
		95007
	],
	"./de/deposits.json": [
		51972,
		51972
	],
	"./de/dialogs.json": [
		46428,
		46428
	],
	"./de/diceRoll.json": [
		16226,
		16226
	],
	"./de/dogTreasure.json": [
		73247,
		73247
	],
	"./de/dogTreasureTerms.json": [
		80886,
		80886
	],
	"./de/easterApril2025.json": [
		26994,
		26994
	],
	"./de/easterMissions.json": [
		3546,
		3546
	],
	"./de/fiestaJune25LP.json": [
		96261,
		96261
	],
	"./de/fruitsupMarch25.json": [
		73471,
		73471
	],
	"./de/gatesOfOlympusLP.json": [
		72264,
		72264
	],
	"./de/glossary.json": [
		69115,
		69115
	],
	"./de/history.json": [
		88559,
		88559
	],
	"./de/jackpot.json": [
		77783,
		77783
	],
	"./de/juicyCarMay2025.json": [
		83214,
		83214
	],
	"./de/juicyMay.json": [
		35851,
		35851
	],
	"./de/leaveDeposit.json": [
		23251,
		23251
	],
	"./de/leaveRegistration.json": [
		30979,
		30979
	],
	"./de/limits.json": [
		57546,
		57546
	],
	"./de/lobby.json": [
		88804,
		88804
	],
	"./de/lootboxes.json": [
		90603,
		90603
	],
	"./de/loyalty.json": [
		81133,
		81133
	],
	"./de/lpAssets.json": [
		99434,
		99434
	],
	"./de/lyzer40BanksBenefitsJune2025LP.json": [
		86692,
		86692
	],
	"./de/march2025.json": [
		25915,
		25915
	],
	"./de/mobileApp.json": [
		33409,
		33409
	],
	"./de/personal.json": [
		21518,
		21518
	],
	"./de/profile.json": [
		35158,
		35158
	],
	"./de/promotions.json": [
		31464,
		31464
	],
	"./de/referralSystem.json": [
		370,
		370
	],
	"./de/regDragonRewards.json": [
		51316,
		51316
	],
	"./de/regRewards.json": [
		49635,
		49635
	],
	"./de/scratchGame.json": [
		70914,
		70914
	],
	"./de/security.json": [
		36798,
		36798
	],
	"./de/sharkJuly25LP.json": [
		34768,
		34768
	],
	"./de/slotsCircle.json": [
		96047,
		96047
	],
	"./de/sportsDeposit.json": [
		64412,
		64412
	],
	"./de/sunOfEgypt.json": [
		87116,
		87116
	],
	"./de/support.json": [
		53227,
		53227
	],
	"./de/turbolvlJuly25LP.json": [
		23779,
		23779
	],
	"./de/validation.json": [
		21621,
		21621
	],
	"./de/verification.json": [
		6114,
		6114
	],
	"./de/vip.json": [
		78534,
		78534
	],
	"./de/vipGemCards.json": [
		13554,
		13554
	],
	"./de/welcomeApril2025.json": [
		40052,
		47414
	],
	"./de/wheel.json": [
		36793,
		36793
	],
	"./de/wheelFortuneLP.json": [
		42123,
		42123
	],
	"./de/winterJanuary.json": [
		35168,
		35168
	],
	"./de/withdraw.json": [
		15401,
		15401
	],
	"./de/wolfElvisSunBuffalo.json": [
		33865,
		33865
	],
	"./de/wolfWheelLP.json": [
		84879,
		84879
	],
	"./en-AU/CardsBenefitsJune2025LP.json": [
		37651,
		33183
	],
	"./en-AU/QuizBonusJune2025LP.json": [
		48023,
		48023
	],
	"./en-AU/aviatorup.json": [
		24052,
		24052
	],
	"./en-AU/banksBenefitsMay2025.json": [
		49390,
		49390
	],
	"./en-AU/becomeVip.json": [
		39083,
		39083
	],
	"./en-AU/bigBass.json": [
		50581,
		50581
	],
	"./en-AU/blackWheelLP.json": [
		2580,
		2580
	],
	"./en-AU/bonanzaPromo.json": [
		6838,
		6838
	],
	"./en-AU/bonusClaimLP.json": [
		15618,
		15618
	],
	"./en-AU/bonuses.json": [
		66240,
		66240
	],
	"./en-AU/buffaloWheel.json": [
		44909,
		44909
	],
	"./en-AU/carways2025LP.json": [
		81973,
		81973
	],
	"./en-AU/cashbox.json": [
		29007,
		29007
	],
	"./en-AU/cashupBonanza.json": [
		26447,
		26447
	],
	"./en-AU/centredRegFormLP.json": [
		11268,
		11268
	],
	"./en-AU/circleLP.json": [
		8960,
		8960
	],
	"./en-AU/circusNovember.json": [
		76279,
		76279
	],
	"./en-AU/common.json": [
		95556,
		95556
	],
	"./en-AU/crownApril25.json": [
		7306,
		7306
	],
	"./en-AU/crownBanner.json": [
		92357,
		92357
	],
	"./en-AU/crownMarch25.json": [
		36417,
		36417
	],
	"./en-AU/crownWheelBlack.json": [
		62092,
		62092
	],
	"./en-AU/crownWheelBlackLP.json": [
		40494,
		40494
	],
	"./en-AU/cryptoExclusiveMay25LP.json": [
		15974,
		15974
	],
	"./en-AU/cryptoOfferMay25LP.json": [
		95682,
		95682
	],
	"./en-AU/deposits.json": [
		5773,
		5773
	],
	"./en-AU/dialogs.json": [
		72012,
		72012
	],
	"./en-AU/diceRoll.json": [
		9941,
		9941
	],
	"./en-AU/dogTreasure.json": [
		96292,
		96292
	],
	"./en-AU/dogTreasureTerms.json": [
		57813,
		57813
	],
	"./en-AU/easterApril2025.json": [
		50450,
		50450
	],
	"./en-AU/easterMissions.json": [
		41412,
		41412
	],
	"./en-AU/fiestaJune25LP.json": [
		92799,
		92799
	],
	"./en-AU/fruitsupMarch25.json": [
		53942,
		53942
	],
	"./en-AU/gatesOfOlympusLP.json": [
		90797,
		90797
	],
	"./en-AU/glossary.json": [
		42609,
		42609
	],
	"./en-AU/history.json": [
		73859,
		73859
	],
	"./en-AU/jackpot.json": [
		33364,
		33364
	],
	"./en-AU/juicyCarMay2025.json": [
		82399,
		82399
	],
	"./en-AU/juicyMay.json": [
		458,
		458
	],
	"./en-AU/leaveDeposit.json": [
		27057,
		27057
	],
	"./en-AU/leaveRegistration.json": [
		31167,
		31167
	],
	"./en-AU/limits.json": [
		69107,
		69107
	],
	"./en-AU/lobby.json": [
		65158,
		65158
	],
	"./en-AU/lootboxes.json": [
		25889,
		25889
	],
	"./en-AU/loyalty.json": [
		98524,
		98524
	],
	"./en-AU/lpAssets.json": [
		81854,
		81854
	],
	"./en-AU/lyzer40BanksBenefitsJune2025LP.json": [
		51977,
		51977
	],
	"./en-AU/march2025.json": [
		26776,
		26776
	],
	"./en-AU/mobileApp.json": [
		82649,
		82649
	],
	"./en-AU/personal.json": [
		32042,
		32042
	],
	"./en-AU/profile.json": [
		82082,
		82082
	],
	"./en-AU/promotions.json": [
		30196,
		30196
	],
	"./en-AU/referralSystem.json": [
		11804,
		11804
	],
	"./en-AU/regDragonRewards.json": [
		34217,
		34217
	],
	"./en-AU/regRewards.json": [
		29242,
		29242
	],
	"./en-AU/scratchGame.json": [
		5792,
		5792
	],
	"./en-AU/security.json": [
		2716,
		2716
	],
	"./en-AU/sharkJuly25LP.json": [
		76854,
		76854
	],
	"./en-AU/slotsCircle.json": [
		15014,
		15014
	],
	"./en-AU/sportsDeposit.json": [
		4015,
		4015
	],
	"./en-AU/sunOfEgypt.json": [
		66490,
		66490
	],
	"./en-AU/support.json": [
		36346,
		36346
	],
	"./en-AU/turbolvlJuly25LP.json": [
		96312,
		96312
	],
	"./en-AU/validation.json": [
		91447,
		91447
	],
	"./en-AU/verification.json": [
		13823,
		13823
	],
	"./en-AU/vip.json": [
		7218,
		7218
	],
	"./en-AU/vipGemCards.json": [
		65508,
		65508
	],
	"./en-AU/welcomeApril2025.json": [
		15730,
		15730
	],
	"./en-AU/wheel.json": [
		72125,
		72125
	],
	"./en-AU/wheelFortuneLP.json": [
		17103,
		17103
	],
	"./en-AU/winterJanuary.json": [
		35369,
		35369
	],
	"./en-AU/withdraw.json": [
		79511,
		79511
	],
	"./en-AU/wolfElvisSunBuffalo.json": [
		10349,
		10349
	],
	"./en-AU/wolfWheelLP.json": [
		5402,
		5402
	],
	"./en-CA/CardsBenefitsJune2025LP.json": [
		90930,
		90930
	],
	"./en-CA/QuizBonusJune2025LP.json": [
		85191,
		85191
	],
	"./en-CA/aviatorup.json": [
		38849,
		38849
	],
	"./en-CA/banksBenefitsMay2025.json": [
		86918,
		86918
	],
	"./en-CA/becomeVip.json": [
		23904,
		23904
	],
	"./en-CA/bigBass.json": [
		80239,
		80239
	],
	"./en-CA/blackWheelLP.json": [
		20273,
		20273
	],
	"./en-CA/bonanzaPromo.json": [
		62107,
		62107
	],
	"./en-CA/bonusClaimLP.json": [
		46694,
		46694
	],
	"./en-CA/bonuses.json": [
		53950,
		53950
	],
	"./en-CA/buffaloWheel.json": [
		37744,
		37744
	],
	"./en-CA/carways2025LP.json": [
		20800,
		20800
	],
	"./en-CA/cashbox.json": [
		80949,
		80949
	],
	"./en-CA/cashupBonanza.json": [
		82605,
		82605
	],
	"./en-CA/centredRegFormLP.json": [
		94082,
		94082
	],
	"./en-CA/circleLP.json": [
		85570,
		88291
	],
	"./en-CA/circusNovember.json": [
		30406,
		30406
	],
	"./en-CA/common.json": [
		81242,
		81242
	],
	"./en-CA/crownApril25.json": [
		59686,
		59686
	],
	"./en-CA/crownBanner.json": [
		32345,
		32345
	],
	"./en-CA/crownMarch25.json": [
		94959,
		94959
	],
	"./en-CA/crownWheelBlack.json": [
		85016,
		85016
	],
	"./en-CA/crownWheelBlackLP.json": [
		61781,
		61781
	],
	"./en-CA/cryptoExclusiveMay25LP.json": [
		40644,
		40644
	],
	"./en-CA/cryptoOfferMay25LP.json": [
		62749,
		62749
	],
	"./en-CA/deposits.json": [
		20176,
		20176
	],
	"./en-CA/dialogs.json": [
		16793,
		16793
	],
	"./en-CA/diceRoll.json": [
		8406,
		8406
	],
	"./en-CA/dogTreasure.json": [
		4827,
		4827
	],
	"./en-CA/dogTreasureTerms.json": [
		61671,
		61671
	],
	"./en-CA/easterApril2025.json": [
		19858,
		19858
	],
	"./en-CA/easterMissions.json": [
		90912,
		90912
	],
	"./en-CA/fiestaJune25LP.json": [
		16832,
		16832
	],
	"./en-CA/fruitsupMarch25.json": [
		35045,
		35045
	],
	"./en-CA/gatesOfOlympusLP.json": [
		56845,
		56845
	],
	"./en-CA/glossary.json": [
		76053,
		46917
	],
	"./en-CA/history.json": [
		70286,
		70286
	],
	"./en-CA/jackpot.json": [
		67083,
		67083
	],
	"./en-CA/juicyCarMay2025.json": [
		19297,
		19297
	],
	"./en-CA/juicyMay.json": [
		308,
		308
	],
	"./en-CA/leaveDeposit.json": [
		90104,
		90104
	],
	"./en-CA/leaveRegistration.json": [
		39877,
		39877
	],
	"./en-CA/limits.json": [
		89500,
		89500
	],
	"./en-CA/lobby.json": [
		27919,
		27919
	],
	"./en-CA/lootboxes.json": [
		15991,
		15991
	],
	"./en-CA/loyalty.json": [
		66609,
		66609
	],
	"./en-CA/lpAssets.json": [
		28033,
		28033
	],
	"./en-CA/lyzer40BanksBenefitsJune2025LP.json": [
		55702,
		55702
	],
	"./en-CA/march2025.json": [
		21045,
		21045
	],
	"./en-CA/mobileApp.json": [
		9116,
		9116
	],
	"./en-CA/personal.json": [
		6640,
		6640
	],
	"./en-CA/profile.json": [
		50945,
		50945
	],
	"./en-CA/promotions.json": [
		64042,
		64042
	],
	"./en-CA/referralSystem.json": [
		10284,
		10284
	],
	"./en-CA/regDragonRewards.json": [
		37020,
		37020
	],
	"./en-CA/regRewards.json": [
		10586,
		10586
	],
	"./en-CA/scratchGame.json": [
		86598,
		86598
	],
	"./en-CA/security.json": [
		51401,
		51401
	],
	"./en-CA/sharkJuly25LP.json": [
		71348,
		71348
	],
	"./en-CA/slotsCircle.json": [
		54810,
		54810
	],
	"./en-CA/sportsDeposit.json": [
		42901,
		42901
	],
	"./en-CA/sunOfEgypt.json": [
		26748,
		26748
	],
	"./en-CA/support.json": [
		79678,
		79678
	],
	"./en-CA/turbolvlJuly25LP.json": [
		93103,
		93103
	],
	"./en-CA/validation.json": [
		66077,
		66077
	],
	"./en-CA/verification.json": [
		70454,
		70454
	],
	"./en-CA/vip.json": [
		38717,
		38717
	],
	"./en-CA/vipGemCards.json": [
		34423,
		34423
	],
	"./en-CA/welcomeApril2025.json": [
		9251,
		9251
	],
	"./en-CA/wheel.json": [
		63956,
		63956
	],
	"./en-CA/wheelFortuneLP.json": [
		42988,
		42988
	],
	"./en-CA/winterJanuary.json": [
		98566,
		98566
	],
	"./en-CA/withdraw.json": [
		6081,
		6081
	],
	"./en-CA/wolfElvisSunBuffalo.json": [
		45293,
		45293
	],
	"./en-CA/wolfWheelLP.json": [
		7527,
		7527
	],
	"./en-IE/CardsBenefitsJune2025LP.json": [
		79965,
		79965
	],
	"./en-IE/QuizBonusJune2025LP.json": [
		39822,
		39822
	],
	"./en-IE/aviatorup.json": [
		61932,
		61932
	],
	"./en-IE/banksBenefitsMay2025.json": [
		85982,
		85982
	],
	"./en-IE/becomeVip.json": [
		83815,
		83815
	],
	"./en-IE/bigBass.json": [
		33412,
		33412
	],
	"./en-IE/blackWheelLP.json": [
		80204,
		80204
	],
	"./en-IE/bonanzaPromo.json": [
		74322,
		74322
	],
	"./en-IE/bonusClaimLP.json": [
		23764,
		23764
	],
	"./en-IE/bonuses.json": [
		41426,
		41426
	],
	"./en-IE/buffaloWheel.json": [
		98358,
		98358
	],
	"./en-IE/carways2025LP.json": [
		10248,
		10248
	],
	"./en-IE/cashbox.json": [
		54875,
		54875
	],
	"./en-IE/cashupBonanza.json": [
		85440,
		85440
	],
	"./en-IE/centredRegFormLP.json": [
		67002,
		67002
	],
	"./en-IE/circleLP.json": [
		51355,
		51355
	],
	"./en-IE/circusNovember.json": [
		48082,
		48082
	],
	"./en-IE/common.json": [
		98403,
		98403
	],
	"./en-IE/crownApril25.json": [
		7856,
		7856
	],
	"./en-IE/crownBanner.json": [
		32181,
		32181
	],
	"./en-IE/crownMarch25.json": [
		65219,
		65219
	],
	"./en-IE/crownWheelBlack.json": [
		54217,
		54217
	],
	"./en-IE/crownWheelBlackLP.json": [
		28485,
		28485
	],
	"./en-IE/cryptoExclusiveMay25LP.json": [
		15142,
		15142
	],
	"./en-IE/cryptoOfferMay25LP.json": [
		27590,
		27590
	],
	"./en-IE/deposits.json": [
		62058,
		62058
	],
	"./en-IE/dialogs.json": [
		58471,
		58471
	],
	"./en-IE/diceRoll.json": [
		94503,
		94503
	],
	"./en-IE/dogTreasure.json": [
		9880,
		9880
	],
	"./en-IE/dogTreasureTerms.json": [
		83268,
		83268
	],
	"./en-IE/easterApril2025.json": [
		15413,
		15413
	],
	"./en-IE/easterMissions.json": [
		94678,
		94678
	],
	"./en-IE/fiestaJune25LP.json": [
		75457,
		75457
	],
	"./en-IE/fruitsupMarch25.json": [
		79130,
		79130
	],
	"./en-IE/gatesOfOlympusLP.json": [
		56250,
		56250
	],
	"./en-IE/glossary.json": [
		46559,
		46559
	],
	"./en-IE/history.json": [
		64998,
		64998
	],
	"./en-IE/jackpot.json": [
		57565,
		57565
	],
	"./en-IE/juicyCarMay2025.json": [
		56378,
		56378
	],
	"./en-IE/juicyMay.json": [
		53421,
		53421
	],
	"./en-IE/leaveDeposit.json": [
		36026,
		36026
	],
	"./en-IE/leaveRegistration.json": [
		62578,
		62578
	],
	"./en-IE/limits.json": [
		14483,
		14483
	],
	"./en-IE/lobby.json": [
		49136,
		49136
	],
	"./en-IE/lootboxes.json": [
		68556,
		68556
	],
	"./en-IE/loyalty.json": [
		8409,
		8409
	],
	"./en-IE/lpAssets.json": [
		55570,
		55570
	],
	"./en-IE/lyzer40BanksBenefitsJune2025LP.json": [
		58254,
		58254
	],
	"./en-IE/march2025.json": [
		49173,
		49173
	],
	"./en-IE/mobileApp.json": [
		53075,
		53075
	],
	"./en-IE/personal.json": [
		74946,
		74946
	],
	"./en-IE/profile.json": [
		92498,
		92498
	],
	"./en-IE/promotions.json": [
		33658,
		33658
	],
	"./en-IE/referralSystem.json": [
		75378,
		75378
	],
	"./en-IE/regDragonRewards.json": [
		44810,
		44810
	],
	"./en-IE/regRewards.json": [
		83797,
		83797
	],
	"./en-IE/scratchGame.json": [
		16508,
		16508
	],
	"./en-IE/security.json": [
		68485,
		68485
	],
	"./en-IE/sharkJuly25LP.json": [
		97832,
		97832
	],
	"./en-IE/slotsCircle.json": [
		31283,
		31283
	],
	"./en-IE/sportsDeposit.json": [
		74774,
		46544
	],
	"./en-IE/sunOfEgypt.json": [
		27162,
		31079
	],
	"./en-IE/support.json": [
		59176,
		59176
	],
	"./en-IE/turbolvlJuly25LP.json": [
		24416,
		24416
	],
	"./en-IE/validation.json": [
		96629,
		96629
	],
	"./en-IE/verification.json": [
		74054,
		74054
	],
	"./en-IE/vip.json": [
		44221,
		44221
	],
	"./en-IE/vipGemCards.json": [
		38563,
		38563
	],
	"./en-IE/welcomeApril2025.json": [
		68482,
		68482
	],
	"./en-IE/wheel.json": [
		5879,
		5879
	],
	"./en-IE/wheelFortuneLP.json": [
		17905,
		17905
	],
	"./en-IE/winterJanuary.json": [
		26909,
		26909
	],
	"./en-IE/withdraw.json": [
		79187,
		79187
	],
	"./en-IE/wolfElvisSunBuffalo.json": [
		98560,
		98560
	],
	"./en-IE/wolfWheelLP.json": [
		8518,
		8518
	],
	"./en-NZ/CardsBenefitsJune2025LP.json": [
		76651,
		76651
	],
	"./en-NZ/QuizBonusJune2025LP.json": [
		87945,
		87945
	],
	"./en-NZ/aviatorup.json": [
		99322,
		99322
	],
	"./en-NZ/banksBenefitsMay2025.json": [
		80939,
		80939
	],
	"./en-NZ/becomeVip.json": [
		63801,
		63801
	],
	"./en-NZ/bigBass.json": [
		93534,
		93534
	],
	"./en-NZ/blackWheelLP.json": [
		97606,
		97606
	],
	"./en-NZ/bonanzaPromo.json": [
		15845,
		15845
	],
	"./en-NZ/bonusClaimLP.json": [
		82034,
		82034
	],
	"./en-NZ/bonuses.json": [
		93208,
		93208
	],
	"./en-NZ/buffaloWheel.json": [
		66860,
		66860
	],
	"./en-NZ/carways2025LP.json": [
		66151,
		66151
	],
	"./en-NZ/cashbox.json": [
		24074,
		24074
	],
	"./en-NZ/cashupBonanza.json": [
		10736,
		10736
	],
	"./en-NZ/centredRegFormLP.json": [
		94130,
		94130
	],
	"./en-NZ/circleLP.json": [
		63509,
		63509
	],
	"./en-NZ/circusNovember.json": [
		11838,
		11838
	],
	"./en-NZ/common.json": [
		97853,
		97853
	],
	"./en-NZ/crownApril25.json": [
		51989,
		51989
	],
	"./en-NZ/crownBanner.json": [
		26306,
		26306
	],
	"./en-NZ/crownMarch25.json": [
		55977,
		55977
	],
	"./en-NZ/crownWheelBlack.json": [
		94892,
		94892
	],
	"./en-NZ/crownWheelBlackLP.json": [
		42507,
		42507
	],
	"./en-NZ/cryptoExclusiveMay25LP.json": [
		63799,
		63799
	],
	"./en-NZ/cryptoOfferMay25LP.json": [
		12093,
		12093
	],
	"./en-NZ/deposits.json": [
		85985,
		85985
	],
	"./en-NZ/dialogs.json": [
		41843,
		41843
	],
	"./en-NZ/diceRoll.json": [
		89715,
		89715
	],
	"./en-NZ/dogTreasure.json": [
		97220,
		97220
	],
	"./en-NZ/dogTreasureTerms.json": [
		9607,
		9607
	],
	"./en-NZ/easterApril2025.json": [
		32254,
		23977
	],
	"./en-NZ/easterMissions.json": [
		7422,
		7422
	],
	"./en-NZ/fiestaJune25LP.json": [
		4681,
		4681
	],
	"./en-NZ/fruitsupMarch25.json": [
		70279,
		70279
	],
	"./en-NZ/gatesOfOlympusLP.json": [
		97545,
		97545
	],
	"./en-NZ/glossary.json": [
		39244,
		39244
	],
	"./en-NZ/history.json": [
		87689,
		87689
	],
	"./en-NZ/jackpot.json": [
		28997,
		28997
	],
	"./en-NZ/juicyCarMay2025.json": [
		84146,
		84146
	],
	"./en-NZ/juicyMay.json": [
		21603,
		21603
	],
	"./en-NZ/leaveDeposit.json": [
		91693,
		91693
	],
	"./en-NZ/leaveRegistration.json": [
		83030,
		83030
	],
	"./en-NZ/limits.json": [
		52187,
		52187
	],
	"./en-NZ/lobby.json": [
		93193,
		93193
	],
	"./en-NZ/lootboxes.json": [
		43834,
		43834
	],
	"./en-NZ/loyalty.json": [
		87922,
		87922
	],
	"./en-NZ/lpAssets.json": [
		77083,
		77083
	],
	"./en-NZ/lyzer40BanksBenefitsJune2025LP.json": [
		1068,
		1068
	],
	"./en-NZ/march2025.json": [
		88587,
		88587
	],
	"./en-NZ/mobileApp.json": [
		86863,
		86863
	],
	"./en-NZ/personal.json": [
		96075,
		96075
	],
	"./en-NZ/profile.json": [
		36161,
		36161
	],
	"./en-NZ/promotions.json": [
		2295,
		2295
	],
	"./en-NZ/referralSystem.json": [
		67521,
		67521
	],
	"./en-NZ/regDragonRewards.json": [
		72591,
		72591
	],
	"./en-NZ/regRewards.json": [
		34289,
		34289
	],
	"./en-NZ/scratchGame.json": [
		40601,
		40601
	],
	"./en-NZ/security.json": [
		53158,
		53158
	],
	"./en-NZ/sharkJuly25LP.json": [
		27693,
		27693
	],
	"./en-NZ/slotsCircle.json": [
		62769,
		62769
	],
	"./en-NZ/sportsDeposit.json": [
		41324,
		41324
	],
	"./en-NZ/sunOfEgypt.json": [
		28996,
		28996
	],
	"./en-NZ/support.json": [
		48133,
		48133
	],
	"./en-NZ/turbolvlJuly25LP.json": [
		6439,
		6439
	],
	"./en-NZ/validation.json": [
		41120,
		41120
	],
	"./en-NZ/verification.json": [
		46578,
		46578
	],
	"./en-NZ/vip.json": [
		92396,
		92396
	],
	"./en-NZ/vipGemCards.json": [
		20688,
		20688
	],
	"./en-NZ/welcomeApril2025.json": [
		33873,
		33873
	],
	"./en-NZ/wheel.json": [
		48374,
		48374
	],
	"./en-NZ/wheelFortuneLP.json": [
		28250,
		28250
	],
	"./en-NZ/winterJanuary.json": [
		24727,
		24727
	],
	"./en-NZ/withdraw.json": [
		85890,
		85890
	],
	"./en-NZ/wolfElvisSunBuffalo.json": [
		11019,
		11019
	],
	"./en-NZ/wolfWheelLP.json": [
		42798,
		42798
	],
	"./en/CardsBenefitsJune2025LP.json": [
		96117,
		96117
	],
	"./en/QuizBonusJune2025LP.json": [
		40128,
		40128
	],
	"./en/aviatorup.json": [
		94728,
		94728
	],
	"./en/banksBenefitsMay2025.json": [
		1291,
		1291
	],
	"./en/becomeVip.json": [
		91900,
		23730
	],
	"./en/bigBass.json": [
		47780,
		47780
	],
	"./en/blackWheelLP.json": [
		21007,
		21007
	],
	"./en/bonanzaPromo.json": [
		881,
		881
	],
	"./en/bonusClaimLP.json": [
		40365,
		40365
	],
	"./en/bonuses.json": [
		58045,
		58045
	],
	"./en/buffaloWheel.json": [
		13829,
		13829
	],
	"./en/carways2025LP.json": [
		97595,
		97595
	],
	"./en/cashbox.json": [
		25945,
		25945
	],
	"./en/cashupBonanza.json": [
		92372,
		92372
	],
	"./en/centredRegFormLP.json": [
		27565,
		94940
	],
	"./en/circleLP.json": [
		77388,
		77388
	],
	"./en/circusNovember.json": [
		69900,
		69900
	],
	"./en/common.json": [
		30202,
		30202
	],
	"./en/crownApril25.json": [
		43034,
		43034
	],
	"./en/crownBanner.json": [
		68457,
		68457
	],
	"./en/crownMarch25.json": [
		14779,
		14779
	],
	"./en/crownWheelBlack.json": [
		13035,
		65871
	],
	"./en/crownWheelBlackLP.json": [
		6742,
		6742
	],
	"./en/cryptoExclusiveMay25LP.json": [
		44779,
		44779
	],
	"./en/cryptoOfferMay25LP.json": [
		67646,
		67646
	],
	"./en/deposits.json": [
		90536,
		90536
	],
	"./en/dialogs.json": [
		67896,
		22148
	],
	"./en/diceRoll.json": [
		67269,
		67269
	],
	"./en/dogTreasure.json": [
		49945,
		49945
	],
	"./en/dogTreasureTerms.json": [
		26080,
		26080
	],
	"./en/easterApril2025.json": [
		4778,
		4778
	],
	"./en/easterMissions.json": [
		85274,
		85274
	],
	"./en/fiestaJune25LP.json": [
		64864,
		64864
	],
	"./en/fruitsupMarch25.json": [
		7924,
		7924
	],
	"./en/gatesOfOlympusLP.json": [
		21199,
		21199
	],
	"./en/glossary.json": [
		3540,
		3540
	],
	"./en/history.json": [
		58323,
		58323
	],
	"./en/jackpot.json": [
		45353,
		45353
	],
	"./en/juicyCarMay2025.json": [
		82646,
		82646
	],
	"./en/juicyMay.json": [
		54767,
		54767
	],
	"./en/leaveDeposit.json": [
		62873,
		92312
	],
	"./en/leaveRegistration.json": [
		37607,
		37607
	],
	"./en/limits.json": [
		43683,
		43683
	],
	"./en/lobby.json": [
		90949,
		90949
	],
	"./en/lootboxes.json": [
		21285,
		21285
	],
	"./en/loyalty.json": [
		20590,
		20590
	],
	"./en/lpAssets.json": [
		340,
		340
	],
	"./en/lyzer40BanksBenefitsJune2025LP.json": [
		32290,
		32290
	],
	"./en/march2025.json": [
		52482,
		52482
	],
	"./en/mobileApp.json": [
		90942,
		31767
	],
	"./en/personal.json": [
		35751,
		35751
	],
	"./en/profile.json": [
		48776,
		48776
	],
	"./en/promotions.json": [
		79033,
		79033
	],
	"./en/referralSystem.json": [
		74982,
		74982
	],
	"./en/regDragonRewards.json": [
		64763,
		64763
	],
	"./en/regRewards.json": [
		86955,
		86955
	],
	"./en/scratchGame.json": [
		15946,
		15946
	],
	"./en/security.json": [
		14138,
		14138
	],
	"./en/sharkJuly25LP.json": [
		87708,
		87708
	],
	"./en/slotsCircle.json": [
		60106,
		60106
	],
	"./en/sportsDeposit.json": [
		62965,
		62965
	],
	"./en/sunOfEgypt.json": [
		87078,
		87078
	],
	"./en/support.json": [
		25030,
		25030
	],
	"./en/turbolvlJuly25LP.json": [
		47859,
		47859
	],
	"./en/validation.json": [
		25997,
		25997
	],
	"./en/verification.json": [
		55725,
		55725
	],
	"./en/vip.json": [
		17938,
		17938
	],
	"./en/vipGemCards.json": [
		13792,
		13792
	],
	"./en/welcomeApril2025.json": [
		75904,
		75904
	],
	"./en/wheel.json": [
		85610,
		85610
	],
	"./en/wheelFortuneLP.json": [
		85039,
		85039
	],
	"./en/winterJanuary.json": [
		76642,
		76642
	],
	"./en/withdraw.json": [
		71883,
		71883
	],
	"./en/wolfElvisSunBuffalo.json": [
		73280,
		73280
	],
	"./en/wolfWheelLP.json": [
		24817,
		24817
	],
	"./et-EE/CardsBenefitsJune2025LP.json": [
		66673,
		66673
	],
	"./et-EE/QuizBonusJune2025LP.json": [
		9109,
		62873
	],
	"./et-EE/aviatorup.json": [
		49951,
		49951
	],
	"./et-EE/banksBenefitsMay2025.json": [
		44808,
		44808
	],
	"./et-EE/becomeVip.json": [
		46138,
		46138
	],
	"./et-EE/bigBass.json": [
		45933,
		45933
	],
	"./et-EE/blackWheelLP.json": [
		79964,
		79964
	],
	"./et-EE/bonanzaPromo.json": [
		75660,
		75660
	],
	"./et-EE/bonusClaimLP.json": [
		19644,
		19644
	],
	"./et-EE/bonuses.json": [
		21003,
		21003
	],
	"./et-EE/buffaloWheel.json": [
		85958,
		85958
	],
	"./et-EE/carways2025LP.json": [
		75820,
		75820
	],
	"./et-EE/cashbox.json": [
		49781,
		49781
	],
	"./et-EE/cashupBonanza.json": [
		73222,
		73222
	],
	"./et-EE/centredRegFormLP.json": [
		72857,
		72857
	],
	"./et-EE/circleLP.json": [
		93599,
		93599
	],
	"./et-EE/circusNovember.json": [
		33488,
		33488
	],
	"./et-EE/common.json": [
		46223,
		46223
	],
	"./et-EE/crownApril25.json": [
		48903,
		48903
	],
	"./et-EE/crownBanner.json": [
		85371,
		85371
	],
	"./et-EE/crownMarch25.json": [
		65778,
		65778
	],
	"./et-EE/crownWheelBlack.json": [
		42851,
		42851
	],
	"./et-EE/crownWheelBlackLP.json": [
		55903,
		55903
	],
	"./et-EE/cryptoExclusiveMay25LP.json": [
		1817,
		1817
	],
	"./et-EE/cryptoOfferMay25LP.json": [
		51625,
		51625
	],
	"./et-EE/deposits.json": [
		59257,
		59257
	],
	"./et-EE/dialogs.json": [
		3856,
		5803
	],
	"./et-EE/diceRoll.json": [
		98831,
		98831
	],
	"./et-EE/dogTreasure.json": [
		15713,
		15713
	],
	"./et-EE/dogTreasureTerms.json": [
		91099,
		91099
	],
	"./et-EE/easterApril2025.json": [
		5813,
		5813
	],
	"./et-EE/easterMissions.json": [
		6556,
		6556
	],
	"./et-EE/fiestaJune25LP.json": [
		58391,
		58391
	],
	"./et-EE/fruitsupMarch25.json": [
		26364,
		26364
	],
	"./et-EE/gatesOfOlympusLP.json": [
		52679,
		52679
	],
	"./et-EE/glossary.json": [
		99803,
		99803
	],
	"./et-EE/history.json": [
		43049,
		43049
	],
	"./et-EE/jackpot.json": [
		55832,
		55832
	],
	"./et-EE/juicyCarMay2025.json": [
		4324,
		4324
	],
	"./et-EE/juicyMay.json": [
		68931,
		68931
	],
	"./et-EE/leaveDeposit.json": [
		89905,
		89905
	],
	"./et-EE/leaveRegistration.json": [
		43322,
		43322
	],
	"./et-EE/limits.json": [
		50971,
		50971
	],
	"./et-EE/lobby.json": [
		98518,
		98518
	],
	"./et-EE/lootboxes.json": [
		69319,
		69319
	],
	"./et-EE/loyalty.json": [
		23123,
		23123
	],
	"./et-EE/lpAssets.json": [
		27604,
		27604
	],
	"./et-EE/lyzer40BanksBenefitsJune2025LP.json": [
		95893,
		95893
	],
	"./et-EE/march2025.json": [
		10525,
		10525
	],
	"./et-EE/mobileApp.json": [
		77411,
		77411
	],
	"./et-EE/personal.json": [
		4447,
		4447
	],
	"./et-EE/profile.json": [
		94289,
		94289
	],
	"./et-EE/promotions.json": [
		62412,
		62412
	],
	"./et-EE/referralSystem.json": [
		33816,
		33816
	],
	"./et-EE/regDragonRewards.json": [
		35821,
		90483
	],
	"./et-EE/regRewards.json": [
		53293,
		53293
	],
	"./et-EE/scratchGame.json": [
		23396,
		23396
	],
	"./et-EE/security.json": [
		92499,
		92499
	],
	"./et-EE/sharkJuly25LP.json": [
		21088,
		21088
	],
	"./et-EE/slotsCircle.json": [
		5736,
		5736
	],
	"./et-EE/sportsDeposit.json": [
		6774,
		6774
	],
	"./et-EE/sunOfEgypt.json": [
		26643,
		26643
	],
	"./et-EE/support.json": [
		80157,
		80157
	],
	"./et-EE/turbolvlJuly25LP.json": [
		27946,
		27946
	],
	"./et-EE/validation.json": [
		98590,
		98590
	],
	"./et-EE/verification.json": [
		12776,
		12776
	],
	"./et-EE/vip.json": [
		45184,
		45184
	],
	"./et-EE/vipGemCards.json": [
		2123,
		2123
	],
	"./et-EE/welcomeApril2025.json": [
		55344,
		55344
	],
	"./et-EE/wheel.json": [
		40448,
		40448
	],
	"./et-EE/wheelFortuneLP.json": [
		28073,
		28073
	],
	"./et-EE/winterJanuary.json": [
		82100,
		82100
	],
	"./et-EE/withdraw.json": [
		28330,
		28330
	],
	"./et-EE/wolfElvisSunBuffalo.json": [
		79471,
		79471
	],
	"./et-EE/wolfWheelLP.json": [
		77210,
		77210
	],
	"./fi/CardsBenefitsJune2025LP.json": [
		52263,
		52263
	],
	"./fi/QuizBonusJune2025LP.json": [
		73597,
		73597
	],
	"./fi/aviatorup.json": [
		93021,
		93021
	],
	"./fi/banksBenefitsMay2025.json": [
		47338,
		47338
	],
	"./fi/becomeVip.json": [
		34573,
		34573
	],
	"./fi/bigBass.json": [
		31503,
		31503
	],
	"./fi/blackWheelLP.json": [
		18336,
		18336
	],
	"./fi/bonanzaPromo.json": [
		7568,
		7568
	],
	"./fi/bonusClaimLP.json": [
		97573,
		97573
	],
	"./fi/bonuses.json": [
		12197,
		12197
	],
	"./fi/buffaloWheel.json": [
		46629,
		46629
	],
	"./fi/carways2025LP.json": [
		83980,
		83980
	],
	"./fi/cashbox.json": [
		14558,
		14558
	],
	"./fi/cashupBonanza.json": [
		91122,
		91122
	],
	"./fi/centredRegFormLP.json": [
		85231,
		85231
	],
	"./fi/circleLP.json": [
		4250,
		4250
	],
	"./fi/circusNovember.json": [
		67627,
		67627
	],
	"./fi/common.json": [
		74582,
		74582
	],
	"./fi/crownApril25.json": [
		92608,
		92608
	],
	"./fi/crownBanner.json": [
		75473,
		75473
	],
	"./fi/crownMarch25.json": [
		11121,
		11121
	],
	"./fi/crownWheelBlack.json": [
		13405,
		13405
	],
	"./fi/crownWheelBlackLP.json": [
		64079,
		64079
	],
	"./fi/cryptoExclusiveMay25LP.json": [
		32902,
		32902
	],
	"./fi/cryptoOfferMay25LP.json": [
		39986,
		39986
	],
	"./fi/deposits.json": [
		51387,
		51387
	],
	"./fi/dialogs.json": [
		27015,
		27015
	],
	"./fi/diceRoll.json": [
		40376,
		40376
	],
	"./fi/dogTreasure.json": [
		41628,
		41628
	],
	"./fi/dogTreasureTerms.json": [
		96768,
		96768
	],
	"./fi/easterApril2025.json": [
		25283,
		25283
	],
	"./fi/easterMissions.json": [
		46088,
		46088
	],
	"./fi/fiestaJune25LP.json": [
		24904,
		24904
	],
	"./fi/fruitsupMarch25.json": [
		14697,
		14697
	],
	"./fi/gatesOfOlympusLP.json": [
		18609,
		18609
	],
	"./fi/glossary.json": [
		295,
		295
	],
	"./fi/history.json": [
		12258,
		12258
	],
	"./fi/jackpot.json": [
		37160,
		86527
	],
	"./fi/juicyCarMay2025.json": [
		82872,
		82872
	],
	"./fi/juicyMay.json": [
		47066,
		47066
	],
	"./fi/leaveDeposit.json": [
		40566,
		40566
	],
	"./fi/leaveRegistration.json": [
		31729,
		31729
	],
	"./fi/limits.json": [
		66775,
		66775
	],
	"./fi/lobby.json": [
		95512,
		95512
	],
	"./fi/lootboxes.json": [
		67190,
		67190
	],
	"./fi/loyalty.json": [
		20249,
		20249
	],
	"./fi/lpAssets.json": [
		12728,
		12728
	],
	"./fi/lyzer40BanksBenefitsJune2025LP.json": [
		9870,
		9870
	],
	"./fi/march2025.json": [
		90179,
		90179
	],
	"./fi/mobileApp.json": [
		56825,
		56825
	],
	"./fi/personal.json": [
		26733,
		26733
	],
	"./fi/profile.json": [
		30193,
		30193
	],
	"./fi/promotions.json": [
		14273,
		14273
	],
	"./fi/referralSystem.json": [
		67029,
		67029
	],
	"./fi/regDragonRewards.json": [
		23783,
		23783
	],
	"./fi/regRewards.json": [
		31759,
		31759
	],
	"./fi/scratchGame.json": [
		30462,
		30462
	],
	"./fi/security.json": [
		55063,
		55063
	],
	"./fi/sharkJuly25LP.json": [
		71657,
		71657
	],
	"./fi/slotsCircle.json": [
		94521,
		94521
	],
	"./fi/sportsDeposit.json": [
		54650,
		54650
	],
	"./fi/sunOfEgypt.json": [
		83626,
		83626
	],
	"./fi/support.json": [
		16426,
		16426
	],
	"./fi/turbolvlJuly25LP.json": [
		43986,
		43986
	],
	"./fi/validation.json": [
		88078,
		88078
	],
	"./fi/verification.json": [
		54543,
		54543
	],
	"./fi/vip.json": [
		21290,
		21290
	],
	"./fi/vipGemCards.json": [
		87280,
		87280
	],
	"./fi/welcomeApril2025.json": [
		37922,
		28720
	],
	"./fi/wheel.json": [
		2553,
		2553
	],
	"./fi/wheelFortuneLP.json": [
		14407,
		14407
	],
	"./fi/winterJanuary.json": [
		82727,
		82727
	],
	"./fi/withdraw.json": [
		20376,
		20376
	],
	"./fi/wolfElvisSunBuffalo.json": [
		22269,
		22269
	],
	"./fi/wolfWheelLP.json": [
		78169,
		78169
	],
	"./fr-CA/CardsBenefitsJune2025LP.json": [
		76666,
		76666
	],
	"./fr-CA/QuizBonusJune2025LP.json": [
		79486,
		79486
	],
	"./fr-CA/aviatorup.json": [
		11049,
		11049
	],
	"./fr-CA/banksBenefitsMay2025.json": [
		12886,
		12886
	],
	"./fr-CA/becomeVip.json": [
		78902,
		78902
	],
	"./fr-CA/bigBass.json": [
		4062,
		4062
	],
	"./fr-CA/blackWheelLP.json": [
		78956,
		78956
	],
	"./fr-CA/bonanzaPromo.json": [
		81121,
		81121
	],
	"./fr-CA/bonusClaimLP.json": [
		64136,
		64136
	],
	"./fr-CA/bonuses.json": [
		90869,
		90869
	],
	"./fr-CA/buffaloWheel.json": [
		4705,
		4705
	],
	"./fr-CA/carways2025LP.json": [
		3642,
		3642
	],
	"./fr-CA/cashbox.json": [
		596,
		596
	],
	"./fr-CA/cashupBonanza.json": [
		69938,
		69938
	],
	"./fr-CA/centredRegFormLP.json": [
		37522,
		37522
	],
	"./fr-CA/circleLP.json": [
		63196,
		63196
	],
	"./fr-CA/circusNovember.json": [
		83858,
		83858
	],
	"./fr-CA/common.json": [
		73577,
		73577
	],
	"./fr-CA/crownApril25.json": [
		26307,
		26307
	],
	"./fr-CA/crownBanner.json": [
		26761,
		26761
	],
	"./fr-CA/crownMarch25.json": [
		84444,
		84444
	],
	"./fr-CA/crownWheelBlack.json": [
		27788,
		27788
	],
	"./fr-CA/crownWheelBlackLP.json": [
		225,
		225
	],
	"./fr-CA/cryptoExclusiveMay25LP.json": [
		40669,
		40669
	],
	"./fr-CA/cryptoOfferMay25LP.json": [
		63564,
		63564
	],
	"./fr-CA/deposits.json": [
		32549,
		32549
	],
	"./fr-CA/dialogs.json": [
		7927,
		7927
	],
	"./fr-CA/diceRoll.json": [
		14338,
		14338
	],
	"./fr-CA/dogTreasure.json": [
		29447,
		29447
	],
	"./fr-CA/dogTreasureTerms.json": [
		74264,
		74264
	],
	"./fr-CA/easterApril2025.json": [
		98005,
		98005
	],
	"./fr-CA/easterMissions.json": [
		97446,
		97446
	],
	"./fr-CA/fiestaJune25LP.json": [
		65270,
		65270
	],
	"./fr-CA/fruitsupMarch25.json": [
		95603,
		95603
	],
	"./fr-CA/gatesOfOlympusLP.json": [
		90694,
		90694
	],
	"./fr-CA/glossary.json": [
		1751,
		1751
	],
	"./fr-CA/history.json": [
		9676,
		9676
	],
	"./fr-CA/jackpot.json": [
		94793,
		94793
	],
	"./fr-CA/juicyCarMay2025.json": [
		62664,
		62664
	],
	"./fr-CA/juicyMay.json": [
		87437,
		87437
	],
	"./fr-CA/leaveDeposit.json": [
		84580,
		84580
	],
	"./fr-CA/leaveRegistration.json": [
		98814,
		98814
	],
	"./fr-CA/limits.json": [
		40061,
		40061
	],
	"./fr-CA/lobby.json": [
		19592,
		19592
	],
	"./fr-CA/lootboxes.json": [
		61980,
		61980
	],
	"./fr-CA/loyalty.json": [
		94150,
		94150
	],
	"./fr-CA/lpAssets.json": [
		97906,
		97906
	],
	"./fr-CA/lyzer40BanksBenefitsJune2025LP.json": [
		42594,
		42594
	],
	"./fr-CA/march2025.json": [
		74698,
		74698
	],
	"./fr-CA/mobileApp.json": [
		28739,
		28739
	],
	"./fr-CA/personal.json": [
		11891,
		13924
	],
	"./fr-CA/profile.json": [
		85792,
		85792
	],
	"./fr-CA/promotions.json": [
		58194,
		45614
	],
	"./fr-CA/referralSystem.json": [
		46683,
		46683
	],
	"./fr-CA/regDragonRewards.json": [
		38833,
		38833
	],
	"./fr-CA/regRewards.json": [
		55203,
		55203
	],
	"./fr-CA/scratchGame.json": [
		23772,
		23772
	],
	"./fr-CA/security.json": [
		68984,
		68984
	],
	"./fr-CA/sharkJuly25LP.json": [
		99272,
		99272
	],
	"./fr-CA/slotsCircle.json": [
		65789,
		65789
	],
	"./fr-CA/sportsDeposit.json": [
		39361,
		39361
	],
	"./fr-CA/sunOfEgypt.json": [
		53744,
		53744
	],
	"./fr-CA/support.json": [
		47359,
		47359
	],
	"./fr-CA/turbolvlJuly25LP.json": [
		85615,
		85615
	],
	"./fr-CA/validation.json": [
		50555,
		50555
	],
	"./fr-CA/verification.json": [
		72772,
		72772
	],
	"./fr-CA/vip.json": [
		65086,
		65086
	],
	"./fr-CA/vipGemCards.json": [
		20556,
		20556
	],
	"./fr-CA/welcomeApril2025.json": [
		52650,
		52650
	],
	"./fr-CA/wheel.json": [
		65588,
		65588
	],
	"./fr-CA/wheelFortuneLP.json": [
		73734,
		73734
	],
	"./fr-CA/winterJanuary.json": [
		63910,
		63910
	],
	"./fr-CA/withdraw.json": [
		53445,
		53445
	],
	"./fr-CA/wolfElvisSunBuffalo.json": [
		98927,
		98927
	],
	"./fr-CA/wolfWheelLP.json": [
		82524,
		82524
	],
	"./fr-CH/CardsBenefitsJune2025LP.json": [
		50021,
		50021
	],
	"./fr-CH/QuizBonusJune2025LP.json": [
		17517,
		17517
	],
	"./fr-CH/aviatorup.json": [
		39959,
		39959
	],
	"./fr-CH/banksBenefitsMay2025.json": [
		89047,
		89047
	],
	"./fr-CH/becomeVip.json": [
		37097,
		37097
	],
	"./fr-CH/bigBass.json": [
		67464,
		13035
	],
	"./fr-CH/blackWheelLP.json": [
		18727,
		18727
	],
	"./fr-CH/bonanzaPromo.json": [
		19267,
		19267
	],
	"./fr-CH/bonusClaimLP.json": [
		49202,
		49202
	],
	"./fr-CH/bonuses.json": [
		4866,
		4866
	],
	"./fr-CH/buffaloWheel.json": [
		94771,
		94771
	],
	"./fr-CH/carways2025LP.json": [
		65250,
		65250
	],
	"./fr-CH/cashbox.json": [
		43481,
		43481
	],
	"./fr-CH/cashupBonanza.json": [
		53489,
		53489
	],
	"./fr-CH/centredRegFormLP.json": [
		26196,
		26196
	],
	"./fr-CH/circleLP.json": [
		87048,
		87048
	],
	"./fr-CH/circusNovember.json": [
		81792,
		81792
	],
	"./fr-CH/common.json": [
		97794,
		97794
	],
	"./fr-CH/crownApril25.json": [
		77200,
		77200
	],
	"./fr-CH/crownBanner.json": [
		21460,
		21460
	],
	"./fr-CH/crownMarch25.json": [
		26275,
		26275
	],
	"./fr-CH/crownWheelBlack.json": [
		64919,
		64919
	],
	"./fr-CH/crownWheelBlackLP.json": [
		44868,
		44868
	],
	"./fr-CH/cryptoExclusiveMay25LP.json": [
		89781,
		89781
	],
	"./fr-CH/cryptoOfferMay25LP.json": [
		8392,
		8392
	],
	"./fr-CH/deposits.json": [
		42846,
		42846
	],
	"./fr-CH/dialogs.json": [
		89906,
		38665
	],
	"./fr-CH/diceRoll.json": [
		94986,
		94986
	],
	"./fr-CH/dogTreasure.json": [
		59931,
		59931
	],
	"./fr-CH/dogTreasureTerms.json": [
		10096,
		10096
	],
	"./fr-CH/easterApril2025.json": [
		54366,
		54366
	],
	"./fr-CH/easterMissions.json": [
		37250,
		37250
	],
	"./fr-CH/fiestaJune25LP.json": [
		75897,
		75897
	],
	"./fr-CH/fruitsupMarch25.json": [
		20321,
		20321
	],
	"./fr-CH/gatesOfOlympusLP.json": [
		53139,
		53139
	],
	"./fr-CH/glossary.json": [
		60055,
		60055
	],
	"./fr-CH/history.json": [
		4127,
		4127
	],
	"./fr-CH/jackpot.json": [
		12469,
		12469
	],
	"./fr-CH/juicyCarMay2025.json": [
		15741,
		15741
	],
	"./fr-CH/juicyMay.json": [
		67907,
		67907
	],
	"./fr-CH/leaveDeposit.json": [
		7823,
		7823
	],
	"./fr-CH/leaveRegistration.json": [
		85884,
		85884
	],
	"./fr-CH/limits.json": [
		15053,
		15053
	],
	"./fr-CH/lobby.json": [
		94422,
		94422
	],
	"./fr-CH/lootboxes.json": [
		36136,
		36136
	],
	"./fr-CH/loyalty.json": [
		10188,
		10188
	],
	"./fr-CH/lpAssets.json": [
		83721,
		83721
	],
	"./fr-CH/lyzer40BanksBenefitsJune2025LP.json": [
		44225,
		44225
	],
	"./fr-CH/march2025.json": [
		95337,
		55029
	],
	"./fr-CH/mobileApp.json": [
		13873,
		13873
	],
	"./fr-CH/personal.json": [
		24850,
		24850
	],
	"./fr-CH/profile.json": [
		56151,
		56151
	],
	"./fr-CH/promotions.json": [
		57166,
		57166
	],
	"./fr-CH/referralSystem.json": [
		98338,
		98338
	],
	"./fr-CH/regDragonRewards.json": [
		35631,
		35631
	],
	"./fr-CH/regRewards.json": [
		77997,
		77997
	],
	"./fr-CH/scratchGame.json": [
		95727,
		95727
	],
	"./fr-CH/security.json": [
		39776,
		39776
	],
	"./fr-CH/sharkJuly25LP.json": [
		93405,
		93405
	],
	"./fr-CH/slotsCircle.json": [
		35534,
		35534
	],
	"./fr-CH/sportsDeposit.json": [
		8764,
		71195
	],
	"./fr-CH/sunOfEgypt.json": [
		35480,
		35480
	],
	"./fr-CH/support.json": [
		44566,
		44566
	],
	"./fr-CH/turbolvlJuly25LP.json": [
		56939,
		56939
	],
	"./fr-CH/validation.json": [
		49537,
		49537
	],
	"./fr-CH/verification.json": [
		19342,
		19342
	],
	"./fr-CH/vip.json": [
		65782,
		65782
	],
	"./fr-CH/vipGemCards.json": [
		64576,
		64576
	],
	"./fr-CH/welcomeApril2025.json": [
		17497,
		17497
	],
	"./fr-CH/wheel.json": [
		83643,
		83643
	],
	"./fr-CH/wheelFortuneLP.json": [
		20532,
		20532
	],
	"./fr-CH/winterJanuary.json": [
		15276,
		15276
	],
	"./fr-CH/withdraw.json": [
		90547,
		90547
	],
	"./fr-CH/wolfElvisSunBuffalo.json": [
		10853,
		10853
	],
	"./fr-CH/wolfWheelLP.json": [
		55324,
		55324
	],
	"./no/CardsBenefitsJune2025LP.json": [
		70640,
		70640
	],
	"./no/QuizBonusJune2025LP.json": [
		36143,
		36143
	],
	"./no/aviatorup.json": [
		74307,
		74307
	],
	"./no/banksBenefitsMay2025.json": [
		67891,
		67891
	],
	"./no/becomeVip.json": [
		42864,
		42864
	],
	"./no/bigBass.json": [
		86243,
		86243
	],
	"./no/blackWheelLP.json": [
		84871,
		84871
	],
	"./no/bonanzaPromo.json": [
		85329,
		85329
	],
	"./no/bonusClaimLP.json": [
		57646,
		57646
	],
	"./no/bonuses.json": [
		68552,
		68552
	],
	"./no/buffaloWheel.json": [
		96108,
		96108
	],
	"./no/carways2025LP.json": [
		86804,
		86804
	],
	"./no/cashbox.json": [
		47683,
		47683
	],
	"./no/cashupBonanza.json": [
		86621,
		86621
	],
	"./no/centredRegFormLP.json": [
		78018,
		78018
	],
	"./no/circleLP.json": [
		24249,
		98269
	],
	"./no/circusNovember.json": [
		10074,
		10074
	],
	"./no/common.json": [
		28363,
		28363
	],
	"./no/crownApril25.json": [
		85834,
		85834
	],
	"./no/crownBanner.json": [
		43455,
		43455
	],
	"./no/crownMarch25.json": [
		49054,
		49054
	],
	"./no/crownWheelBlack.json": [
		49728,
		49728
	],
	"./no/crownWheelBlackLP.json": [
		5423,
		5423
	],
	"./no/cryptoExclusiveMay25LP.json": [
		38440,
		38440
	],
	"./no/cryptoOfferMay25LP.json": [
		76208,
		76208
	],
	"./no/deposits.json": [
		8762,
		8762
	],
	"./no/dialogs.json": [
		44522,
		44522
	],
	"./no/diceRoll.json": [
		70691,
		70691
	],
	"./no/dogTreasure.json": [
		42366,
		42366
	],
	"./no/dogTreasureTerms.json": [
		9817,
		9817
	],
	"./no/easterApril2025.json": [
		261,
		261
	],
	"./no/easterMissions.json": [
		77635,
		77635
	],
	"./no/fiestaJune25LP.json": [
		42270,
		42270
	],
	"./no/fruitsupMarch25.json": [
		4684,
		4684
	],
	"./no/gatesOfOlympusLP.json": [
		29295,
		28329
	],
	"./no/glossary.json": [
		35060,
		35060
	],
	"./no/history.json": [
		56292,
		56292
	],
	"./no/jackpot.json": [
		4394,
		4394
	],
	"./no/juicyCarMay2025.json": [
		52240,
		52240
	],
	"./no/juicyMay.json": [
		99015,
		99015
	],
	"./no/leaveDeposit.json": [
		63204,
		63204
	],
	"./no/leaveRegistration.json": [
		58765,
		58765
	],
	"./no/limits.json": [
		5348,
		5348
	],
	"./no/lobby.json": [
		97503,
		97503
	],
	"./no/lootboxes.json": [
		34400,
		34400
	],
	"./no/loyalty.json": [
		3378,
		3378
	],
	"./no/lpAssets.json": [
		12997,
		12997
	],
	"./no/lyzer40BanksBenefitsJune2025LP.json": [
		15064,
		15064
	],
	"./no/march2025.json": [
		13429,
		13429
	],
	"./no/mobileApp.json": [
		28088,
		28088
	],
	"./no/personal.json": [
		7595,
		7595
	],
	"./no/profile.json": [
		11490,
		11490
	],
	"./no/promotions.json": [
		35075,
		35075
	],
	"./no/referralSystem.json": [
		9421,
		9421
	],
	"./no/regDragonRewards.json": [
		92986,
		92986
	],
	"./no/regRewards.json": [
		55225,
		55225
	],
	"./no/scratchGame.json": [
		62225,
		62225
	],
	"./no/security.json": [
		3065,
		3065
	],
	"./no/sharkJuly25LP.json": [
		4519,
		4519
	],
	"./no/slotsCircle.json": [
		18195,
		18195
	],
	"./no/sportsDeposit.json": [
		64303,
		64303
	],
	"./no/sunOfEgypt.json": [
		75152,
		75152
	],
	"./no/support.json": [
		93543,
		93543
	],
	"./no/turbolvlJuly25LP.json": [
		67958,
		67958
	],
	"./no/validation.json": [
		30740,
		30740
	],
	"./no/verification.json": [
		7462,
		84738
	],
	"./no/vip.json": [
		48258,
		48258
	],
	"./no/vipGemCards.json": [
		61449,
		61449
	],
	"./no/welcomeApril2025.json": [
		55265,
		55265
	],
	"./no/wheel.json": [
		22357,
		22357
	],
	"./no/wheelFortuneLP.json": [
		12148,
		12148
	],
	"./no/winterJanuary.json": [
		57229,
		57229
	],
	"./no/withdraw.json": [
		85873,
		85873
	],
	"./no/wolfElvisSunBuffalo.json": [
		58789,
		58789
	],
	"./no/wolfWheelLP.json": [
		16379,
		16379
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 90492;
module.exports = webpackAsyncContext;